export default __webpack_public_path__ + "static/media/stock-vault.c7da89f1.png";